import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { css } from "@emotion/css";

const mcpUrl = process.env.REACT_APP_API_URL_V2 + "/mcp";
const claudeCodeCommand = `claude mcp add --transport http ja-content ${mcpUrl}`;

const CopyableLine: React.VFC<{ text: string }> = ({ text }) => {
  const [copied, setCopied] = React.useState(false);
  return (
    <Box className={styles.line}>
      <code className={styles.code}>{text}</code>
      <Tooltip title={copied ? "Copied" : "Copy"}>
        <IconButton size="small" onClick={() => navigator.clipboard.writeText(text).then(() => setCopied(true))}>
          <FileCopyOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const ClaudeSetup: React.VFC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>🤖 Edit content with Claude</DialogTitle>
    <DialogContent className={styles.content}>
      <Typography variant="body1">
        Claude can read and edit exercises, lessons, schedules and health forms for you. It signs in as you and goes
        through the same checks as this backoffice. Publishing releases to stage; releasing to prod stays here.
      </Typography>

      <Typography variant="h6">Claude Code</Typography>
      <CopyableLine text={claudeCodeCommand} />
      <Typography variant="body2" color="textSecondary">
        Then run <code>/mcp</code>, pick <code>ja-content</code> and sign in with Google.
      </Typography>

      <Typography variant="h6">Claude app or claude.ai</Typography>
      <Typography variant="body2">
        On the Joint Academy Claude account: Settings ▸ Connectors, find <code>ja-content</code> and connect it.
      </Typography>
      <Typography variant="body2">
        On any other account: Settings ▸ Connectors ▸ Add custom connector, name it <code>ja-content</code> and use this
        URL:
      </Typography>
      <CopyableLine text={mcpUrl} />

      <Typography variant="h6">Starting from an item</Typography>
      <Typography variant="body2">
        The 🤖 buttons on questionnaires, question groups, questions and conditions copy a prompt that names the item.
        Paste it into Claude and finish the sentence.
      </Typography>
    </DialogContent>
  </Dialog>
);

export default ClaudeSetup;

const styles = {
  content: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 24px;
  `,
  line: css`
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 8px 12px;
  `,
  code: css`
    flex: 1;
    font-size: 13px;
    word-break: break-all;
  `,
};
